<template>
  <div class="ordinary-product">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'ordinary-product',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
}
</script>

<style lang="less" scoped>
.ordinary-product {
  height: 100%;
}
</style>
